import { render, staticRenderFns } from "./AuthCarousel2.vue?vue&type=template&id=b41af066&scoped=true&"
import script from "./AuthCarousel2.vue?vue&type=script&lang=js&"
export * from "./AuthCarousel2.vue?vue&type=script&lang=js&"
import style0 from "./AuthCarousel2.vue?vue&type=style&index=0&id=b41af066&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41af066",
  null
  
)

export default component.exports